import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearPostRgrl, getDecretos, postDecretoForm, } from "../../../../redux/actions/rgrl";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledRgrl } from "../../../styled/Prevencion";
import DecretoForm from "./DecretoForm";

const initialValues = {
  id: "",
  nombre: "",
  totalEstablecimientos: "",
  totalTrabajadoresEstablecimientos: "",
  superficie: "",
  observaciones: "",
  idActividad: null,
};

const DecretoContainer = ({ nextForm }) => {
  const dispatch = useDispatch();

  const decretos = useSelector((state) => state.rgrl.decretos);
  const searchedRgrl = useSelector((state) => state.rgrl.searchedRgrl);
  const postDecreto = useSelector((state) => state.rgrl.postRgrl.decretoForm);
  const requerirActividad = useSelector((state) => state.rgrl.requerirActividadDecretos.data);
  const [decretoSeleccionado, setDecretoSeleccionado] = useState(null);
  const [formModel, setFormModel] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  // Selected value es id Actividad o el decreto dependiendo de requerir actividad
  const [selectedValue, setSelectedValue] = useState(null);

  const isLoading = !formModel;

  const getDecretoForActividad = useCallback((idActividad) => {
    if (idActividad) {
      dispatch(getDecretos(searchedRgrl, idActividad)).then((res) => {
        let decretos = res.value.data;

        setDecretoSeleccionado({
          ...decretos.opciones.find((d) => d.id === decretos.valor),
          idActividad,
        });

      });
    } else {
      setDecretoSeleccionado(initialValues);
    }

  }, [searchedRgrl, dispatch, postDecreto])

  useEffect(() => {
    dispatch(getDecretos(searchedRgrl)).then((res) => {
      let decretos = res.value.data;
      if (postDecreto.id) {
        setDecretoSeleccionado(postDecreto);
      } else {
        if (requerirActividad) {
          // Si requiere actividad no configuramos el decreto hasta que se seleccione la actividad
          setDecretoSeleccionado(initialValues);
        } else {
          setDecretoSeleccionado(decretos.opciones.find((d) => d.id === decretos.valor));
        }
      }
    });
  }, []);


  useEffect(() => {
    if (decretoSeleccionado != null) {
      setFormModel(() => ({
        ...initialValues,
        ...decretoSeleccionado,
      }));
    }
  }, [decretoSeleccionado]);

  const handleDecretoChange = (decreto) => {
    setSelectedValue(decreto);
    if (decreto.id !== decretoSeleccionado.id && !!postDecreto?.id) {
      setOpenConfirmDialog(true);
    } else {
      setDecretoSeleccionado(decreto);
    }
  };

  const handleActividadChange = (idActividad) => {
    setSelectedValue(idActividad);
    if (!!postDecreto?.idActividad) {
      setOpenConfirmDialog(true);
    } else {
      getDecretoForActividad(idActividad);
    }
  }

  const handleSubmit = (values) => {
    const objetoAux = {
      ...decretoSeleccionado,
      ...values,
    };
    dispatch(postDecretoForm(objetoAux));
    nextForm("PreguntasDelDecreto");
  };

  return (
    <>
      {!isLoading ? (
        <DecretoForm
          handleSubmit={handleSubmit}
          handleDecretoChange={handleDecretoChange}
          handleActividadChange={handleActividadChange}
          formModel={formModel}
          data={decretos.data}
          setOpenConfirmDialog={setOpenConfirmDialog}
          requerirActividad={requerirActividad}
        />
      ) : (
        <StyledRgrl.LoadingContainer>
          <CircularLoading />
        </StyledRgrl.LoadingContainer>
      )}
      <ConfirmDialog
        open={openConfirmDialog}
        handleClose={() => setOpenConfirmDialog(false)}
        handleConfirm={() => {
          if (!requerirActividad) {
            setDecretoSeleccionado(selectedValue);
          } else {
            getDecretoForActividad(selectedValue);
          }
          setOpenConfirmDialog(false);
          dispatch(clearPostRgrl());
        }}
        title="Perderá todos los datos completados"
        text={
          requerirActividad
            ? "Al seleccionar otra actividad los datos cargados en preguntas se perderán."
            : "Al seleccionar otro decreto los datos cargados en preguntas se perderán."
        }
        loading={false}
      />
    </>
  );
};

export default DecretoContainer;
